import BaseApiClient from '../BaseApiClient';
import {
  managementFirmsSchema,
  reportResponseSchema,
  type SavingsReportRequest
} from './savings-report-types';

const API_VERSION = { Version: '2026-01-20' };

export class ApiSavingsReports extends BaseApiClient {
  async listManagementFirms() {
    const response = await this.client.get<unknown>('/management-firms', {
      headers: API_VERSION
    });
    return managementFirmsSchema.validateSync(response.data, { strict: true })
      .data;
  }

  async get({ kind, params }: SavingsReportRequest) {
    const response = await this.client.get<unknown>(`/${kind}`, {
      headers: API_VERSION,
      params
    });
    return reportResponseSchema.validateSync(response.data, { strict: true })
      .data;
  }
}

export * from './query-keys';
export * from './savings-report-types';
export * from './use-savings-report-queries';
